"use client";

import { openCookieSettings } from "@/lib/cookie-consent";

/**
 * Control that reopens the cookie preferences panel. Kept as a tiny client
 * component so the surrounding footers (and the Cookie Policy page) can stay
 * server components — they just drop this in and style it via `className`.
 */
export function CookieSettingsButton({
  className,
  children = "Cookie settings",
}: {
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <button type="button" onClick={openCookieSettings} className={className}>
      {children}
    </button>
  );
}
